import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material';


@Component({
  selector: 'app-mybusiness-view-dialog',
  templateUrl: './mybusiness-view-dialog.component.html',
  styleUrls: ['./mybusiness-view-dialog.component.css']
})
export class MybusinessViewDialogComponent implements OnInit {

  viewdata: any;

  constructor(
    private dialogRef: MatDialogRef<MybusinessViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: any,
    ) {
      dialogRef.disableClose = true;
      }

    ngOnInit() {
    this.viewdata = this._data;
    // console.log(this.viewdata);

  }

  close() {
    this.dialogRef.close();
  }
}
